import { Service } from '../Service';
import { PanoramaEditor, PanoramaWalkthrough } from './Controllers';
/**
 * API for viewing and positioning panorama models.
 */
export class PanoramaService extends Service {
    constructor(modules, navigationService) {
        super(modules);
        Object.defineProperty(this, "navigationService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "walkthrough", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "editor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.navigationService = navigationService;
        this.walkthrough = new PanoramaWalkthrough(this.renderer, this.gestures, this.navigationService);
        this.editor = new PanoramaEditor(this.renderer, this.gestures, this.navigationService);
    }
    /**
     * Get the walkthrough controller.
     *
     * @returns
     */
    getWalkthrough() {
        return this.walkthrough;
    }
    /**
     * Get the panorama editor controller.
     *
     * @returns
     */
    getEditor() {
        return this.editor;
    }
    /**
     * Update walkthrough per-frame state.
     *
     * @param deltaTime
     */
    updateFrame(deltaTime) {
        this.walkthrough.update();
    }
}
